import "./shop-cards.scss";
import { ShopContext } from "../../context/ShopContext";
import { useContext } from "react";

function ShopCards({ products }) {
  const { addToCart } = useContext(ShopContext);
  return (
    <div className="card-container">
      {products.map((product) => (
        <div className="card-single" key={product.id}>
          <div className="card-single__top">
            <img
              className="card-single__img"
              src={product.img}
              alt={product.alt}
            />
            <button
              className="card-single__button"
              onClick={() => addToCart(product.id)}
            >
              add to cart
            </button>
          </div>
          <div className="card-single__bottom">
            <p className="card-single__text">{product.title}</p>
            <p className="card-single__text">${product.price}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ShopCards;
